export const PLATFORM_AUTH_STORAGE_KEYS = {
  USER: 'platform_auth_user',
  API_TOKEN: 'platform_auth_api_token',
  SESSION_ID: 'platform_auth_session_id',
  BALANCE: 'platform_auth_balance',
}
